import { Select } from "../../../../utils/form";

// Same f/m/o values and labels as the patient form (GenderField) and api (DoctorUser.gender) —
// "o" is also what a DNI "X" maps to.
const GENDERS = [
  { value: "f", text: "Femenino" },
  { value: "m", text: "Masculino" },
  { value: "o", text: "Otro" },
];

const Gender = ({ form: { control } }) => (
  <Select
    control={control}
    name="gender"
    label="Sexo"
    helperText="Según DNI"
    list={GENDERS}
    valueTextGetter={({ text }) => text}
    required
    style={{ width: "100%" }}
  />
);

export default Gender;
